
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function TableIndex() {
  return (
    <NonFSIndex
      data_type="table"
      // save_all
    />
  );
}
